import {Card, List, ListItem, ListItemButton, ListItemText} from "@mui/material";
import React, {Component} from "react";
import "./CustomSelect.scss";
import CheckIcon from '@mui/icons-material/Check';

export interface CustomSelectDataItem {
    value: string;
    text: string;
    selected: boolean;
    data?: any;
}

export interface CustomSelectProps {
    data: CustomSelectDataItem[] | any;
    getToggleButton: (onClick: Function) => any;
    onSelect: (item: CustomSelectDataItem) => void;
}

export interface CustomSelectState {
    opened: boolean;
}

class CustomSelect extends Component<CustomSelectProps, CustomSelectState> {
    constructor(props: CustomSelectProps) {
        super(props);

        this.state = {
            opened: false
        };
    }

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps: CustomSelectProps, nextState: CustomSelectState) {
        return true;
    }

    componentDidUpdate(prevProps: CustomSelectProps, prevState: CustomSelectState) {

    }

    componentWillUnmount() {

    }

    render() {
        return (
            <>
                {
                    this.props.getToggleButton(() => {
                        if (!this.state.opened) {
                            this.setState({opened: true});
                            setTimeout(() => {
                                document.addEventListener('click', this.hide);
                            }, 0);
                        }
                    })
                }
                {
                    this.state.opened && <Card style={{minWidth:"100%"}} className="custom-select">
                        <List
                                        >
                            {
                                this.props.data.map((item: any, i: number) => <ListItem key={i} disablePadding>
                                    <ListItemButton
                                    onClick={() => {
                                        this.props.onSelect(item);
                                    }}>
                                        {item.selected && <><CheckIcon/>&nbsp;&nbsp;</>}
                                        {!item.selected && <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                                        <ListItemText primary={item.text}/>
                                    </ListItemButton>
                                </ListItem>)
                            }
                        </List>
                    </Card>
                }
            </>
        );
    }

    hide = () => {
        if (this.state.opened) {
            this.setState({opened: false});
            setTimeout(() => {
                document.removeEventListener('click', this.hide);
            }, 0);
        }
    }
}

export default CustomSelect;
